import { useGetCurrencyRateQuery } from '@api/api';

export default function useCurrencyConversion() {
  const { data } = useGetCurrencyRateQuery();

  return (amount: number): number => {
    if (!data?.data) {
      return NaN;
    }
    let value = amount / data.data.total;
    value = roundTo(value, 100);
    return value ? value : 1;
  };
}

const roundTo = (value: number, roundTo: number): number => {
  return Math.ceil(value / roundTo) * roundTo;
};
